import Axios from "axios";

import {serverAssetsPath} from "../bvcomponents/assets";
import store from "../store";
import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {getWizardCustomImageUrl, s3FeatureImagePath, THUMBNAIL_SIZES, commonFeaturesThumbnails} from "./utils";
import {
  navItemIsExcluded,
  showWizardInsteadOfQT
} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import Config from "../config";
import {
  hardCodeIsAmericanImport,
  hardCodeIsAmericanStandard,
  hardCodeIsCaesarStone,
  hardCodeIsModerno, hardCodeIsNhance
} from "./fabricatorHardcode";
import {getFeatureGroupIconURL} from "../bvcomponents/bvComponent/core/assets";

const CACHE_NAME = 'image-cache-v1';

export const deregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration) {
        registration.unregister().then((boolean) => {
          if (boolean) {
            console.log('Service Worker unregistered successfully.');
          } else {
            console.log('Service Worker unregistration failed.');
          }
        });
      }
    });
  }
}

export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        // sameServerAssetsPath + `bundle-service-worker.js?isLocal=${isLocal}&v=${Math.random()}`,
        `bundle-service-worker.min.js?v=1`,
        { scope: "/" }
      );
      console.log('Service Worker registered with scope:', registration.scope);
      if (registration.installing) {
        console.log("Service worker installing");
        registration.installing.addEventListener('statechange', async (event) => {
          if (event.target.state === 'activated') {
            console.log('Service worker activated');
            await preCacheImages();
          }
        });
      } else if (registration.waiting) {
        console.log("Service worker installed");
      } else if (registration.active) {
        console.log("Service worker active");
        await preCacheImages();
      }
    } catch (error) {
      console.error(`Registration failed with ${error}`);
    }
  } else {
    await preCacheImages(false); // at least request and hope the browser to cache
  }
};

export const loadImagePromise = async (imageSrc = "", cache) => {
  if (!imageSrc) {
    return Promise.resolve()
  }
  if (cache) {
    const alreadyCached = await cache.match(imageSrc);
    if (alreadyCached) {
      // console.log("alreadyCached", alreadyCached);
      return Promise.resolve()
    }
  }
  return new Promise((resolve) => {
    const image = new Image();
    // image.crossOrigin = 'Anonymous';
    image.onload = () => resolve();
    image.onerror = () => resolve();
    try {
      image.src = imageSrc;
    } catch (e) {
      // console.log(e, 'Can\'t apply image src', layer.image);
    }
  });
};

export const cacheFeaturesThumbnails = async (cache) => {
  const layout = getCurrentLayout();
  const storeState = store.getState();
  const {wizardList, wizardIsActive} = storeState.wizardState;
  let requestImagesArray = [];
  window.t0 = performance.now();

  if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
    wizardList.forEach(wizardItem => {
      wizardItem.wizardGroups.forEach(wizardGroup => {
        if (wizardGroup.scopeImageUrl) {
          const proxyThumbnail = getFeatureGroupIconURL(wizardGroup.scopeImageUrl);
          if (!requestImagesArray.includes(proxyThumbnail)) {
            requestImagesArray.push(proxyThumbnail);
          }
        }
        if (wizardGroup.customImageUrl) {
          const proxyThumbnail = getWizardCustomImageUrl(wizardGroup.customImageUrl);
          if (!requestImagesArray.includes(proxyThumbnail)) {
            requestImagesArray.push(proxyThumbnail);
          }
        }
        if (!wizardGroup.groupName || !layout.allDbFeatures[wizardGroup.groupName]) {
          return
        }
        layout.allDbFeatures[wizardGroup.groupName].forEach(dbFeature => {
          if (!dbFeature.thumbnailUrl || navItemIsExcluded({part: {dbFeature, partName: dbFeature.displayName}}, wizardGroup)) {
            return
          }
          if (commonFeaturesThumbnails[dbFeature.sharedFeatureName]) {
            return;
          }
          commonFeaturesThumbnails[dbFeature.sharedFeatureName] = dbFeature.thumbnailUrl;
          const proxyThumbnail = s3FeatureImagePath(dbFeature, THUMBNAIL_SIZES.medium);
          if (!requestImagesArray.includes(proxyThumbnail)) {
            requestImagesArray.push(proxyThumbnail);
          }
        })
      })
    });
  }
  if (Config.isDevMode()) {
    console.log("thumbnailsArray", requestImagesArray);
    console.log("commonFeaturesThumbnails", Object.keys(commonFeaturesThumbnails).length, commonFeaturesThumbnails);
    console.log("Call to gather thumbnailsArray took " + (performance.now() - window.t0) + " milliseconds.");
    window.t0 = performance.now();
  }
  await Promise.all(requestImagesArray.map((imageSrc) => loadImagePromise(imageSrc, cache)));
  if (Config.isDevMode()) {
    console.log("Call to request thumbnailsArray took " + (performance.now() - window.t0) + " milliseconds.");
  }
  return Promise.resolve()
};

export const preCacheImages = async (withThumbnails = true) => {
  console.log("launching preCacheImages script");
  // if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
  //   navigator.serviceWorker.controller.postMessage({ useCache: true });
  // }
  let cachedImagesArray = await Axios.get(serverAssetsPath + "node/images.json");
  if (cachedImagesArray && cachedImagesArray.data && Array.isArray(cachedImagesArray.data)) {
    const storeState = store.getState();
    const {loaderOpened, loaderTitle, loaderText} = storeState.loaderState;
    let requestArray = cachedImagesArray.data;
    if (hardCodeIsCaesarStone()) {
      requestArray = requestArray.map(imageUrl => imageUrl.replace("images/", "images-caes/"));
    } else if (hardCodeIsAmericanImport() || hardCodeIsAmericanStandard()) {
      requestArray = requestArray.map(imageUrl => imageUrl.replace("images/", "images-as/"));
    } else if (hardCodeIsModerno()) {
      requestArray = requestArray.map(imageUrl => imageUrl.replace("images/", "images-moderno/"));
    } else if (hardCodeIsNhance()) {
      requestArray = requestArray.map(imageUrl => imageUrl.replace("images/", "images-nhance/"));
    }
    if (Config.isDevMode()) {
      console.log("cachedImagesArray", requestArray);
    }
    loaderEnable("loader.cachingOfflineImagesText", loaderTitle);
    let cache = null;
    if (window.caches && window.caches.open) {
      cache = await caches.open(CACHE_NAME);
    }
    await Promise.all(requestArray.map(imageSrc => {
      return loadImagePromise(serverAssetsPath + imageSrc, cache)
    }));
    if (withThumbnails) {
      loaderEnable("loader.cachingOfflineThumbnailsText", loaderTitle);
      await cacheFeaturesThumbnails(cache);
    }
    if (loaderOpened) {
      loaderEnable(loaderText, loaderTitle)
    } else {
      loaderDisable();
    }
  }
}
